var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerTeslaBusy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 59.847,
    viewBox: "0 0 50 59.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b{fill:#fff;}.c{fill:#ff6d5d;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 50,
    height: 59.847,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-285 -339.284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.229 344.284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.229 1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-108-54.207A15.9,15.9,0,0,0-124-70a15.9,15.9,0,0,0-16,15.793c0,10.265,16,26.055,16,26.055s16-15.79,16-26.055",
    transform: "translate(149 76)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.564 9.342)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M217.047,244.121c.131-.162.245-.312.365-.455.757-.9,1.514-1.788,2.265-2.688a.527.527,0,0,1,.513-.207,31.041,31.041,0,0,1,7.065,1.626,6.067,6.067,0,0,1,.59.267,1.476,1.476,0,0,1,.178.126,6.415,6.415,0,0,1-3.4,2.89,4.167,4.167,0,0,1-.184-.447.991.991,0,0,0-.634-.725,16.047,16.047,0,0,0-1.691-.433,5.742,5.742,0,0,0-.943-.058c-.4-.013-.439.021-.52.415q-.274,1.335-.541,2.673-.965,4.764-1.931,9.526-.519,2.552-1.049,5.1a.547.547,0,0,1-.121.253c-.1-.481-.2-.961-.3-1.442q-1.663-8.107-3.32-16.215c-.048-.234-.13-.345-.384-.314-.722.09-1.452.131-2.164.263a1.5,1.5,0,0,0-1.266,1.149,1.748,1.748,0,0,1-.108.24,6.552,6.552,0,0,1-3.43-2.873c.194-.072.341-.13.492-.182,1.048-.359,2.08-.772,3.147-1.058,1.093-.293,2.218-.466,3.331-.677.335-.064.681-.072,1.02-.12a.381.381,0,0,1,.389.162c.769.943,1.547,1.878,2.322,2.816C216.814,243.843,216.9,243.945,217.047,244.121Z",
    transform: "translate(-204.842 -237.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.948,192.41l-.878-1.943a37.466,37.466,0,0,1,24.43,0c-.162.333-.321.653-.48.974s-.315.626-.491.974c-.475-.14-.953-.262-1.419-.42a28.924,28.924,0,0,0-6.694-1.423,35.626,35.626,0,0,0-6.346.008,31.979,31.979,0,0,0-7.342,1.617C185.482,192.279,185.226,192.335,184.948,192.41Z",
    transform: "translate(-184.07 -188.42)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(318 347)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerTeslaBusy);
export default __webpack_public_path__ + "static/media/marker_tesla_busy.e5034b451976b517c28149ce93b14b4d.svg";
export { ForwardRef as ReactComponent };